import { render, staticRenderFns } from "./PaymentMethodButton.vue?vue&type=template&id=09220a77&"
import script from "./PaymentMethodButton.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports